import { createFileRoute, Outlet, useParams } from '@tanstack/react-router';
import z from 'zod';

import { DHChatShell } from '@/components/features/data-harmonization/chat/DHChatShell';
import { DHBreadcrumbs } from '@/features/data-harmonization/DHBreadcrumbs';
import { PageLayout } from '@/features/page-layout/PageLayout';
import { useFeatureFlag } from '@/hooks/use-feature-flag';

export const Route = createFileRoute('/_protected/t/$tenantId/data-harmonization')({
  validateSearch: z.object({
    chatConversationId: z.string().optional().catch(undefined),
  }),
  component: DataHarmonizationLayout,
});

function DataHarmonizationLayout() {
  const { dashboardId, libraryId } = useParams({ strict: false });
  const { chatConversationId } = Route.useSearch();
  const showHeader = Boolean(dashboardId || libraryId);
  const chatDisabled = useFeatureFlag('DISABLE_DH_CHAT', false);

  return (
    <div className="flex size-full">
      <div className="min-w-0 flex-1">
        <PageLayout header={showHeader} classes={{ page: 'flex flex-col !overflow-hidden' }}>
          <DHBreadcrumbs />
          <div className="min-h-0 min-w-0 flex-1 overflow-auto">
            <Outlet />
          </div>
        </PageLayout>
      </div>
      {!chatDisabled && <DHChatShell initialConversationId={chatConversationId} />}
    </div>
  );
}
